export default "__VITE_ASSET__CbEiwuQo__"